import { API_AGGREGATE_SAVINGS } from '@/constants/urls'
import { axiosApi } from '@/services/http/axiosApi'
import Cookies from 'js-cookie'
import { logger } from '@/services/logger'

export const getAggregateSavings = async () => {
  try {
    const { data } = await axiosApi.get(API_AGGREGATE_SAVINGS, {
      params: {
        requestedCurrencyCode: Cookies.get('userCurrency')
      }
    })
    return data
  } catch (err: any) {
    logger.error(err)
  }
}
